var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385.4 385.6",
    style: {
      enableBackground: "new 0 0 385.4 385.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,385.6C86.5,385.6,0,299.1,0,192.8S86.5,0,192.8,0s192.8,86.5,192.8,192.8S299.1,385.6,192.8,385.6z  M192.8,10C92,10,10,92,10,192.8c0,100.8,82,182.8,182.8,182.8c100.8,0,182.8-82,182.8-182.8C375.6,92,293.6,10,192.8,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,231.8c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77 C269.8,197.3,235.3,231.8,192.8,231.8z M192.8,87.7c-37,0-67,30.1-67,67s30.1,67,67,67s67-30.1,67-67S229.7,87.7,192.8,87.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.4,332c-0.5-0.6-51.9-62.1-127-62.1c-75.2,0-125.9,59.5-126.4,60.1l-7.7-6.4c0.5-0.7,13.7-16.2,36.7-31.9 c21.3-14.5,55.5-31.8,97.3-31.8c41.8,0,76.2,17.9,97.7,32.9c23.2,16.2,36.5,32.2,37,32.9L318.4,332z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/User2.761e569c0c56e0833b795affee4a6c5c.svg";
export { ForwardRef as ReactComponent };